import { apiPost, silentFetch } from './api';
import { getPaymentProvider, isNative } from '../utils/platform';

export const TIERS = { FREE: 'free', PREMIUM: 'premium' };

export const TIER_CONFIG = {
  [TIERS.FREE]: {
    label: 'Free',
    monthlyPrice: 0,
    currency: 'GBP',
    features: ['5 lookups/day', 'Local blocklist', 'Community trending'],
  },
  [TIERS.PREMIUM]: {
    label: 'Premium',
    monthlyPrice: 3.99,
    currency: 'GBP',
    features: ['Unlimited lookups', 'Premium scam alerts', 'Weekly digest', 'Priority verification'],
  },
};

// Apple StoreKit product IDs — must match App Store Connect
export const APPLE_PRODUCT_IDS = {
  premium_monthly: 'uk.co.wolftechnologies.spamblocker.premium.monthly',
};

export async function getSubscriptionStatus() {
  // Use silentFetch — fires on every app launch; should never toast.
  const result = await silentFetch('/subscription/status');
  if (!result) {
    return {
      tier: 'free',
      status: null,
      currentPeriodEnd: null,
      cancelAtPeriodEnd: false,
      provider: null,
      entitlements: { unlimitedLookups: false, premiumFilters: false },
    };
  }
  return result;
}

export async function createCheckoutSession() {
  const result = await apiPost('/subscription/checkout', {});
  if (result?.url) window.location.href = result.url;
  return result;
}

export async function verifyCheckoutSession(sessionId) {
  return apiPost('/subscription/verify', { sessionId });
}

export async function openCustomerPortal() {
  const result = await apiPost('/subscription/portal', {});
  if (result?.url) window.location.href = result.url;
  return result;
}
export { openCustomerPortal as createPortalSession };

export async function verifyAppleTransaction({ transactionId, originalTransactionId, productId, userInitiatedAt }) {
  // User-initiated upgrade flow — toast on failure.
  return apiPost('/subscription/apple-verify', {
    transactionId,
    originalTransactionId,
    productId,
    userInitiatedAt,
  });
}

export async function restoreApplePurchases() {
  return apiPost('/subscription/restore', {});
}

export async function startPurchase() {
  const provider = getPaymentProvider();
  if (provider === 'stripe') return createCheckoutSession();
  if (provider === 'apple') {
    // Native flow handled by appleProvider — see services/providers/appleIAP.js
    const { purchasePremium } = await import('./providers/appleIAP');
    return purchasePremium();
  }
  throw new Error(`Payments not supported on ${provider}`);
}

export async function manageSubscription(provider) {
  if (provider === 'stripe' || (!provider && !isNative())) return openCustomerPortal();
  // iOS users manage via Settings > Subscriptions — redirect them there
  if (provider === 'apple' || isNative()) {
    window.open('itms-apps://apps.apple.com/account/subscriptions', '_blank');
    return { url: null };
  }
  return openCustomerPortal();
}
